import { Button, FormHelperText, Grid, Hidden, IconButton, InputLabel } from '@material-ui/core';
import { StyledTableCell, StyledTableRow } from '../../../../../../Core/Controls/Table/StyledCell&Row';
import { CustomChip, InputText, UploadWithBadge } from '../../../../../../Core/Controls';
import { memo, useContext } from 'react';
import { InspectionCheCkContaxt } from './InspectionCheckProvide';
import EditIcon from '@material-ui/icons/Edit';
import { CheckFieldType } from '../CheckFieldType';

const CheckButtonsBorder = {
    D: 'red',
    M: 'orange',
    N: 'blue',
    S: 'green',
    R: 'red'
};

export const InspectionCheckBody = memo(({ p, m, CheckButtons, index }) => {
    const { state, flags, changeResutNotesState, changeState, imageHandler, changeNotesState, handleInpectionRow, actionTakenHandle, widths } =
        useContext(InspectionCheCkContaxt);
    const isRetrunedToEnginner = state.vehicleInspectionStatusID === -1;

    const hasValidationError = Object.keys(state.errors || {}).length > 0;

    const isLegalReqError =
        p.inspectionSheetCheckLegalRequirement === true &&
        ((p.inspectionSheetCheckFieldTypeID === 'CO' && !p.inspectionSheetCheckResultOptionCode) ||
            (p.inspectionSheetCheckFieldTypeID !== 'CO' && !p.inspectionSheetCheckResultEnteredText));

    const isListFailed =
        p.inspectionSheetCheckFieldTypeID === 'LT' &&
        state.listOptionsVM.some(
            (k) =>
                k.inspectionSheetListId === p.inspectionSheetCheckListTypeID &&
                k.name === p.inspectionSheetCheckResultEnteredText &&
                (k.setFailed === true || String(k.setFailed).toLowerCase() === 'true')
        );

    // A check is "failed" when marked as a Defect ('D') or a failed list option.
    const isCheckFailed = p.inspectionSheetCheckResultOptionCode === 'D' || isListFailed;

    // Photo is mandatory when the check is always photo-mandatory, OR the
    // "photo mandatory on fail" flag is set and the check has failed.
    const isPhotoMandatory =
        p.inspectionSheetCheckPhotoMandatory === true ||
        (p.inspectionSheetCheckPhotoMandatoryOnfail === true && isCheckFailed);

    const isPhotoMandatoryError = isPhotoMandatory && !(p.photosUploaded > 0 || p.startPhotosUploaded > 0 || p.basicCount > 0);

    const isDefectNoteError =
        isCheckFailed && (p.inspectionSheetCheckResultNotes == null || p.inspectionSheetCheckResultNotes === '');

    const hasError = hasValidationError && (isLegalReqError || isPhotoMandatoryError || isDefectNoteError);

    return (
        <>
            {/* <Grid item xs={12} style={{ background: index % 2 && '#f5f5f5' }}> */}
            {flags.displayStartEvent ? (
                //OnHire-OffHire Events Body
                <Grid container alignItems="flex-start" style={{ background: index % 2 ? '#ffefef41' : 'white', padding: '3px 0px' }} spacing={2}>
                    <Grid item xl={5} lg={5} md={12} sm={12} xs={12}>
                        <div style={{ fontWeight: 600, marginLeft: widths > 1280 ? 10 : 0, color: hasError ? 'red' : 'black' }}>
                            {p.inspectionSheetCheckDescription} {!!p.inspectionSheetCheckLegalRequirement && <span style={{ color: 'red' }}>*</span>}
                        </div>
                        <div style={{ fontWeight: 400, marginLeft: widths > 1280 ? 10 : 0, color: 'black', fontSize: 11, textAlign: 'justify' }}>
                            {p.inspectionSheetCheckInformation}
                        </div>
                        <div>
                            {p.previousNotes && (
                                <IconButton
                                    style={{
                                        background: CheckButtonsBorder[p?.previousResultCode],
                                        borderRadius: 0,
                                        height: 20,
                                        // width: '100%',
                                        padding: 10,
                                        fontSize: 12
                                    }}
                                    onClick={() => handleInpectionRow(p.previousVehicleInspectionID, p.previousNotes)}
                                >
                                    {' '}
                                    <div item style={{ fontSize: 11, fontWeight: 600, color: 'white', textAlign: 'left' }}>
                                        {p.previousNotes}
                                    </div>
                                </IconButton>
                            )}
                        </div>
                        {hasError && (
                            <FormHelperText error style={{ marginLeft: widths > 1280 ? 10 : 0 }}>
                                {isLegalReqError && 'This check is required.'}
                                {isPhotoMandatoryError && !isLegalReqError && 'Photo is mandatory.'}
                                {isDefectNoteError && !isLegalReqError && !isPhotoMandatoryError && 'Defect description is required.'}
                            </FormHelperText>
                        )}
                        {!p.inspectionSheetCheckResultOptionCode && state.errors?.message ? (
                            <FormHelperText error style={{ marginLeft: widths > 1280 ? 10 : 0 }}>
                                {state.errors?.message}
                            </FormHelperText>
                        ) : null}
                    </Grid>
                    <Grid item xl={1} lg={1} md={2} sm={3} xs={6} style={{ background: 'rgb(175 133 95)' }}>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: p.inspectionSheetCheckCanHidePhotoUpload ? 'flex-start' : 'space-between',
                                alignItems: 'center',
                                padding: '0px 10px'
                            }}
                        >
                            {p.startFreeText ? (
                                <FormHelperText
                                    // onClick={() => handleInpectionRow(p.startVehicleInspectionID, p.startNotes)}
                                    shrink
                                    style={{ fontWeight: 600, fontSize: 15, color: 'black' }}
                                >
                                    {p.startFreeText}
                                </FormHelperText>
                            ) : (
                                state.buttonList.map((b) => {
                                    const Comp = CheckButtons[b.inspectionSheetCheckOptionCode] || ' Button';
                                    const checks = p.startResultCode;

                                    if (checks === b.inspectionSheetCheckOptionCode) {
                                        return (
                                            <span>
                                                <Comp state={true} disabled={true}></Comp>
                                            </span>
                                        );
                                    }
                                })
                            )}
                            {!p.inspectionSheetCheckCanHidePhotoUpload && (
                                <>
                                    <UploadWithBadge
                                        onClick={() => imageHandler(p.startInspectionSheetCheckResultID, p.inspectionSheetCheckID, p.startPhotosUploaded, true)}
                                        count={p.startPhotosUploaded || p.basicCount}
                                        state={p.startPhotosUploaded > 0 || p.basicCount > 0}
                                    />
                                </>
                            )}
                        </div>
                    </Grid>
                    <Grid
                        item
                        xl={p.defectStatusID && isRetrunedToEnginner ? 2 : (p.inspectionSheetCheckCanHideDefectDescription ? 6 : 2)}
                        lg={p.defectStatusID && isRetrunedToEnginner ? 2 : (p.inspectionSheetCheckCanHideDefectDescription ? 6 : 2)}
                        md={7}
                        sm={7}
                        xs={6}
                    >
                        <CheckFieldType
                            fieldTypeId={p.inspectionSheetCheckFieldTypeID}
                            name="inspectionSheetCheckResultNotes"
                            onChange={changeResutNotesState(p.inspectionSheetCheckID, m.inspectionSheetCheckResultEnteredText)}
                            value={p.inspectionSheetCheckResultEnteredText}
                            btnList={state.buttonList}
                            CheckButtons={CheckButtons}
                            changeState={changeState}
                            listOptionsVM={state.listOptionsVM}
                            p={p}
                            listType={p.inspectionSheetCheckListTypeID}
                            photoUploadComponent={
                                !p.inspectionSheetCheckCanHidePhotoUpload && (
                                    <UploadWithBadge
                                        isMandetory={isPhotoMandatory}
                                        onClick={() => imageHandler(p.inspectionSheetCheckResultID, p.inspectionSheetCheckID)}
                                        count={p.photosUploaded || p.basicCount}
                                        state={p.photosUploaded > 0 || p.basicCount > 0}
                                    />
                                )
                            }
                        />
                    </Grid>
                    {!p.inspectionSheetCheckCanHideDefectDescription && (
                        <Grid
                            item
                            xl={p.defectStatusID && isRetrunedToEnginner ? 2 : 4}
                            lg={p.defectStatusID && isRetrunedToEnginner ? 2 : 4}
                            md={12}
                            sm={12}
                            xs={12}
                        >
                            {/* <InputLabel shrink error>
                                    {' '}
                                    {p.startNotes}
                                </InputLabel> */}
                            <InputText
                                error={p.inspectionSheetCheckResultOptionCode === 'D' || p.inspectionSheetCheckResultOptionCode === 'M' || isListFailed ? true : false}
                                placeholder="Defect description"
                                name="inspectionSheetCheckResultNotes"
                                onChange={changeNotesState(p.inspectionSheetCheckID, m.inspectionSheetSectionDescription)}
                                value={p.inspectionSheetCheckResultNotes}
                            />

                            <FormHelperText error>
                                {p.startNotes && (
                                    <IconButton
                                        style={{
                                            // fontWeight: 900,
                                            background: 'rgb(175 133 95)',
                                            borderRadius: 0,
                                            height: 20,
                                            // width: '100%',
                                            padding: 10,
                                            fontSize: 12
                                        }}
                                        onClick={() => handleInpectionRow(p.startVehicleInspectionID, p.startNotes)}
                                    >
                                        {' '}
                                        <div item style={{ fontSize: 11, fontWeight: 600, color: 'black', textAlign: 'left' }}>
                                            {p.startNotes}
                                        </div>
                                    </IconButton>
                                )}
                            </FormHelperText>
                        </Grid>
                    )}
                    {isRetrunedToEnginner && p.defectStatusID ? (
                        <Grid item xl={2} lg={5} md={12} sm={12} xs={12}>
                            {/* {p.defectStatusID && ( */}

                            <CustomChip
                                icon={EditIcon}
                                iconFontSize={16}
                                label={p.defectStatusID !== 1 ? `${p.resultStatus} by ${p.rectifiedBy}` : 'Action'}
                                onClick={() => actionTakenHandle(p)}
                                className="btn-m"
                                style={{
                                    fontWeight: 'bold',
                                    backgroundColor: p.defectStatusID && p.rectifiedBy ? `${p.backgroundColour}` : ''
                                    // color: 'white'
                                }}
                            />

                            {/* )} */}
                        </Grid>
                    ) : null}
                </Grid>
            ) : (
                //Inpsection  Events Body
                <Grid container spacing={2} alignItems="flex-start" style={{ background: index % 2 ? '#ffefef41' : 'white', padding: '5px 0px' }}>
                    <Grid item xl={5} lg={5} md={8} sm={8} xs={12}>
                        <div style={{ fontWeight: 600, marginLeft: widths > 1280 ? 10 : 0, color: hasError ? 'red' : 'black' }}>
                            {p.inspectionSheetCheckDescription} {!!p.inspectionSheetCheckLegalRequirement && <span style={{ color: 'red' }}>*</span>}
                        </div>
                        <div style={{ fontWeight: 400, marginLeft: widths > 1280 ? 10 : 0, color: 'black', fontSize: 11, textAlign: 'justify' }}>
                            {p.inspectionSheetCheckInformation}
                        </div>
                        <div>
                            {p.previousNotes && (
                                <IconButton
                                    style={{
                                        background: CheckButtonsBorder[p?.previousResultCode],
                                        borderRadius: 0,
                                        height: 20,
                                        padding: 10,
                                        fontSize: 12
                                    }}
                                    onClick={() => handleInpectionRow(p.previousVehicleInspectionID, p.previousNotes)}
                                >
                                    {' '}
                                    <div item style={{ fontSize: 11, fontWeight: 600, color: 'white', textAlign: 'left' }}>
                                        {p.previousNotes}
                                    </div>
                                </IconButton>
                            )}
                        </div>
                        {hasError && (
                            <FormHelperText error style={{ marginLeft: widths > 1280 ? 10 : 0 }}>
                                {isLegalReqError && 'This check is required.'}
                                {isPhotoMandatoryError && !isLegalReqError && 'Photo is mandatory.'}
                                {isDefectNoteError && !isLegalReqError && !isPhotoMandatoryError && 'Defect description is required.'}
                            </FormHelperText>
                        )}
                        {!p.inspectionSheetCheckResultOptionCode && state.errors?.message ? (
                            <FormHelperText error style={{ marginLeft: widths > 1280 ? 10 : 0 }}>
                                {state.errors?.message}
                            </FormHelperText>
                        ) : null}
                    </Grid>
                    <Grid
                        item
                        xl={p.defectStatusID && isRetrunedToEnginner ? 2 : (p.inspectionSheetCheckCanHideDefectDescription ? 7 : 2)}
                        lg={p.defectStatusID && isRetrunedToEnginner ? 2 : (p.inspectionSheetCheckCanHideDefectDescription ? 7 : 2)}
                        md={4}
                        sm={4}
                        xs={12}
                    >
                        <CheckFieldType
                            fieldTypeId={p.inspectionSheetCheckFieldTypeID}
                            name="inspectionSheetCheckResultNotes"
                            onChange={changeResutNotesState(p.inspectionSheetCheckID, m.inspectionSheetCheckResultEnteredText)}
                            value={p.inspectionSheetCheckResultEnteredText}
                            btnList={state.buttonList}
                            CheckButtons={CheckButtons}
                            changeState={changeState}
                            listOptionsVM={state.listOptionsVM}
                            p={p}
                            listType={p.inspectionSheetCheckListTypeID}
                            photoUploadComponent={
                                !p.inspectionSheetCheckCanHidePhotoUpload && (
                                    <UploadWithBadge
                                        isMandetory={isPhotoMandatory}
                                        onClick={() => imageHandler(p.inspectionSheetCheckResultID, p.inspectionSheetCheckID)}
                                        count={p.photosUploaded || p.basicCount}
                                        state={p.photosUploaded > 0 || p.basicCount > 0}
                                    />
                                )
                            }
                        />
                    </Grid>
                    {!p.inspectionSheetCheckCanHideDefectDescription && (
                        <Grid
                            item
                            xl={p.defectStatusID && isRetrunedToEnginner ? 3 : 5}
                            lg={p.defectStatusID && isRetrunedToEnginner ? 3 : 5}
                            md={12}
                            sm={12}
                            xs={12}
                        >
                            <InputText
                                error={p.inspectionSheetCheckResultOptionCode === 'D' || p.inspectionSheetCheckResultOptionCode === 'M' || isListFailed ? true : false}
                                placeholder="Defect description"
                                name="inspectionSheetCheckResultNotes"
                                onChange={changeNotesState(p.inspectionSheetCheckID, m.inspectionSheetSectionDescription)}
                                value={p.inspectionSheetCheckResultNotes}
                            />

                            <FormHelperText
                                error
                                style={{
                                    visibility: p.inspectionSheetCheckResultOptionCode === 'D' || p.inspectionSheetCheckResultOptionCode === 'M' || isListFailed ? '' : 'hidden'
                                }}
                            >
                                {state.errors?.note}
                            </FormHelperText>
                        </Grid>
                    )}
                    {isRetrunedToEnginner && p.defectStatusID && (
                        <Grid item xl={2} lg={5} md={12} sm={12} xs={12}>
                            {/* {p.defectStatusID && ( */}

                            <CustomChip
                                icon={EditIcon}
                                iconFontSize={16}
                                label={p.defectStatusID !== 1 ? `${p.resultStatus} by ${p.rectifiedBy}` : 'Action'}
                                onClick={() => actionTakenHandle(p)}
                                className="btn-m"
                                style={{
                                    fontWeight: 'bold',
                                    backgroundColor: p.defectStatusID && p.rectifiedBy ? `${p.backgroundColour}` : ''
                                    // color: 'white'
                                }}
                            />

                            {/* )} */}
                        </Grid>
                    )}
                </Grid>
            )}
            {/* </Grid> */}
        </>
    );
});
